import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'space'
})
export class SpacePipe implements PipeTransform {
  transform(value: string, separator = ','): string {
    return value.split(separator).join(', ');
  }
}
